
const faqs = {
    q1: {
      question: "Why Take This Course?",
      answer:
        "Digital advertising, content creation and strategy, social media, email, and search engine optimization are skills seen as most desirable by employers and are all covered in this course!Not to mention the demand for digital marketing skills has just about doubled between 2011 and 2016, and digital positions have grown 30 percent faster than non-digital roles. "
    },
    q2: {
      question: "What Will I Achieve?",
      answer:
        "You’ll be able to: Navigate through a full arsenal of digital marketing tools like Google AdWords, Facebook, Google Analytics, and more."
    },
    q3: {
      question: "Who’s in My Class?",
      answer:
        "Our Digital Marketing Course is full of a diverse group of students that are as passionate about their craft as you are. From marketers and entrepreneurs to graphic designers to individuals looking for a change in their career, their goals consist of improving their marketing acuity and growing in the industry.  The Lighthouse classrooms are spaces wherein lasting friendships and collaboration opportunities are in abundance and will support you throughout your journey."
    },
    q4: {
      question: "What Skills Will I Leave With?",
      answer:
        "In our Digital Marketing course, you’ll learn: Objective-First Marketing"
    }
  };


export default faqs;